import { Box, Button, TextField } from '@mui/material';
import { useForm } from 'react-hook-form';
import { userRegisterRequest } from '../../actions/auth';
import { useAppDispatch, useAppSelector } from '../../hooks';
import ErrorList from '../ErrorList';

interface Registration {
  name: string;
  email: string;
  password: string;
  password2: string;
}

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function RegisterForm() {
  const dispatch = useAppDispatch();
  const errorMessages = useAppSelector((s) => s.register.errorMessages);
  const {
    register,
    handleSubmit,
    formState: { errors, isValid }
  } = useForm<Registration>({
    mode: 'onChange',
    defaultValues: { name: '', email: '', password: '', password2: '' }
  });

  return (
    <div className="registerForm">
      <ErrorList errorMessages={errorMessages} />
      <Box
        component="form"
        onSubmit={handleSubmit(({ name, email, password: pass }) =>
          dispatch(userRegisterRequest({ name, email, password: pass })))}
        sx={{ maxWidth: 340, mx: 'auto' }}
      >
        <TextField
          {...register('name', { required: true, minLength: 3 })}
          className="nameField"
          label="Imię"
          fullWidth
          margin="normal"
          error={Boolean(errors.name)}
          helperText={errors.name ? 'Imię jest za krótkie' : ''}
        />
        <TextField
          {...register('email', { required: true, pattern: EMAIL })}
          className="emailField"
          label="Email"
          fullWidth
          margin="normal"
          error={Boolean(errors.email)}
          helperText={errors.email ? 'Adres email jest niepoprawny' : ''}
        />
        <TextField
          {...register('password', { required: true, minLength: 7 })}
          className="passwordField"
          label="Hasło"
          type="password"
          fullWidth
          margin="normal"
          error={Boolean(errors.password)}
          helperText={errors.password ? 'Hasło musi być dluższe niż 6 znaków' : ''}
        />
        <TextField
          {...register('password2', { required: true, validate: (v, form) => v === form.password })}
          className="password2Field"
          label="Powtórz hasło"
          type="password"
          fullWidth
          margin="normal"
          error={Boolean(errors.password2)}
          helperText={errors.password2 ? 'Hasła muszą się zgadzać' : ''}
        />
        <Button
          type="submit"
          variant="contained"
          size="large"
          fullWidth
          disabled={!isValid}
          sx={{ mt: 2 }}
        >Zarejestruj</Button>
      </Box>
    </div>
  );
}
